import { render, staticRenderFns } from "./ShipmentError.vue?vue&type=template&id=10a11e9f&"
import script from "./ShipmentError.vue?vue&type=script&lang=js&"
export * from "./ShipmentError.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentError.vue?vue&type=style&index=0&id=10a11e9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports